// imports
import { MouseEvent } from 'react';
import Link from 'next/link';
import { useAtom } from 'jotai';

// lib files
import {
  MyListConfirmModalTypeEnum,
  myListConfirmModalAtom
} from '@/lib/atoms/my-list-confirm-modal';
import { ShowRowContent } from '@/lib/types/api/show-data';

// components
import KabobMenu from '@/components/KabobMenu/KabobMenu';
import ShowPoster, { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';

// svgs
import ShowsIcon from '@/public/svg/shows.svg';
import MinusIcon from '@/public/svg/minus.svg';

// styles
import styles from './MyListShowPoster.module.scss';

interface MyListShowPosterProps {
  show: ShowRowContent;
  showBadgeFlags?: ShowBadgeFlags;
}

const MyListShowPoster = (props: MyListShowPosterProps) => {
  const { show, showBadgeFlags } = props;
  const { slug, cid, title } = show;

  const [ _, setConfirmModalState ] = useAtom(myListConfirmModalAtom);

  const handleRemoveClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const modalState = {
      id: cid,
      isOpen: true,
      slug: slug,
      title: title,
      type: MyListConfirmModalTypeEnum.SHOW,
    }
    setConfirmModalState(modalState);
  }

  return (
    <div className={styles.my_list_show}>
      <ShowPoster show={show} showBadgeFlags={showBadgeFlags} />
      <KabobMenu
        className={styles.my_list_show_kabob_menu}
        contentClassName={styles.my_list_show_kabob_menu_content}
      >
        <ul>
          <li>
            <Link href={`/show/${show.slug}/`} className={styles.my_list_show_link}>
              <ShowsIcon />
              Explore the Show
            </Link>
          </li>
          <li>
            <button
              className={styles.my_list_show_remove_button}
              onClick={handleRemoveClick}>
              <MinusIcon />
              Remove from My List
            </button>
          </li>
        </ul>
      </KabobMenu>
    </div>
  );
};

export default MyListShowPoster;
